module.exports = __webpack_public_path__ + "static/media/kerlighed.d0acba34.jpg";